import { render, staticRenderFns } from "./UserWorkloadToCompaniesModal.vue?vue&type=template&id=a1f1a456&scoped=true"
import script from "./UserWorkloadToCompaniesModal.vue?vue&type=script&lang=js"
export * from "./UserWorkloadToCompaniesModal.vue?vue&type=script&lang=js"
import style0 from "./UserWorkloadToCompaniesModal.vue?vue&type=style&index=0&id=a1f1a456&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f1a456",
  null
  
)

export default component.exports